module.exports = __webpack_public_path__ + "img/ENG-img-04.390d20e5.jpg";